import {
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_REQUEST_VERIFY,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_SET_VERIFY,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_CLEAR_VERIFY,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_SET_UPLOAD,
  BUSINESS_STRUCTURE_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function businessStructureMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case BUSINESS_STRUCTURE_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default businessStructureMassiveUploadReducer;
